"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPrice = void 0;
var formatPrice = function (price) {
    var numericPrice = typeof price === 'number' ? price : parseFloat(price);
    var result = Math.floor(numericPrice).toString();
    return result.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
exports.formatPrice = formatPrice;
